import styled from '@emotion/styled'
import { Box } from 'components/Layout'

const ContentSt = styled(Box)``

export { ContentSt }
